<div class="container products deal">
    <div class="heading heading-flex heading-border mb-3" contentAnim aniName="blurIn">
        <div class="heading-left">
            <h2 class="title">You may also like</h2>
        </div>        
    </div>

    <!--
    <ul ngbNav #nav="ngbNav"  [destroyOnHide]="false"  >
        <li *ngFor="let product of products; let i = index">
                <owl-carousel-o  [options]="customOptions"
                *ngIf="!loaded else elseBlock">
                    <div class="skel-pro" *ngFor="let item of [1,2,3,4,5]"></div>
                </owl-carousel-o>
                
                <ng-template #elseBlock>
                   
                </ng-template>
            
        </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
-->


    <owl-carousel-o  [options]="customOptions" > <!--carouselClasses="owl-simple carousel-equal-height carousel-with-shadow"-->
        <!--<ng-container *ngFor="let product of products; let i for index;">*ngFor="let product of products; let i = index" -->          
            <ng-template carouselSlide [id]="product.id" *ngFor="let product of products;" ><!--class="owl-simple carousel-equal-height carousel-with-shadow" -->                
                <molla-product-six [product]="product" >
                </molla-product-six>                                                    
            </ng-template>                        
        <!--</ng-container>-->
        
    </owl-carousel-o>
    
</div>
<!--
<h2 class="title text-center mb-4">You May Also Like</h2>

    <owl-carousel-o carouselClasses="'owl-simple carousel-equal-height carousel-with-shadow'" [options]="customOptions"
    *ngIf="!loaded else elseBlock">
    <div class="skel-pro" *ngFor="let item of [1,2,3,4,5,6]"></div>
</owl-carousel-o>

<ng-template #elseBlock>
    <owl-carousel-o carouselClasses="'owl-simple carousel-equal-height carousel-with-shadow'" [options]="customOptions">
        <ng-container *ngFor="let product of products">
            <ng-template carouselSlide [id]="product.id.toString()" class="owl-simple carousel-equal-height carousel-with-shadow">
                <molla-product-six [product]="product"></molla-product-six>
            </ng-template>            
        </ng-container>    
    </owl-carousel-o>
</ng-template>
-->